import { render, staticRenderFns } from "./Login_2Col.vue?vue&type=template&id=5370f4a1&scoped=true&"
import script from "./Login_2Col.vue?vue&type=script&lang=js&"
export * from "./Login_2Col.vue?vue&type=script&lang=js&"
import style0 from "./Login_2Col.vue?vue&type=style&index=0&id=5370f4a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370f4a1",
  null
  
)

export default component.exports